import React from 'react';

const CartNavigation = (props) => {
  const { setShowDrawer, showBackButton } = props;
  return (
    <form action="/checkout" method="post" noValidate className="MiniCart__form">
      {/* <button type="submit" name="cart" className="Button" data-style="solid dark-black">
        Checkout Now
      </button> */}
      <a href="/cart" className="Button" data-style="solid dark-black">
        View Cart
      </a>
      <button type="button" className="Button" data-style="outline dark-black" onClick={() => setShowDrawer(false)}>
        Continue Shopping
      </button>
    </form>
  );
};

export default CartNavigation;
